<template>
  <div class="ra-summary--card">
    <div class="rd-summary--card__text">
      <p>{{ label }}</p>
      <slot name="value">
        <h4>{{ value }}</h4>
      </slot>
    </div>
    <div class="rd-summary--card__action">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "RaSummaryCard",
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      required: true
    },
    icon: {
      type: String
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.ra-summary--card {
  background: #fff;
  box-shadow: 0 0 30px 0 rgb(82 63 105 / 7%);
  border-radius: 6px;
  padding: 20px 25px;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  .rd-summary--card__text {
    p {
      letter-spacing: 0.5px;
      font-weight: 500;
      font-size: 0.825rem;
      opacity: 0.5;
      margin-bottom: 3px;
    }

    h4 {
      font-weight: 600;
      font-size: 1.25rem;
    }
  }
}
</style>
